import { NgModule } from '@angular/core';

import { WorkshopPayService } from './workshoppay.service';

@NgModule({
  providers: [
    WorkshopPayService
  ]
})
export class WorkshopPayModule {}
